var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthEndpoints, TokenGrantType, } from './types/auth';
import axios from 'axios';
import axiosBetterStacktrace from 'axios-better-stacktrace';
import qs from 'qs';
import { encode } from 'base-64';
import { requestHeaderCacheControlNoStorage } from './utils';
/**
 * `AuthClient` is a encapsulation of the network request logic needed to authenticate a user.
 * It's intended to be as stateless as possible to simplify testing (it only receives a reference
 * to an `AxiosInstance`, which we can mock out later to create a `MockAuthClient` for testing).
 */
class AuthClient {
    constructor({ auth, baseUrl, userAgent }) {
        this.client = axios.create({
            baseURL: baseUrl,
            timeout: 10000,
            headers: Object.assign(Object.assign(Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, requestHeaderCacheControlNoStorage), (userAgent
                ? {
                    'User-Agent': userAgent,
                }
                : {})), (auth
                ? {
                    Authorization: `Basic ${encode(`${auth.username}:${auth.password}`)}`,
                }
                : {})),
        });
        axiosBetterStacktrace(this.client);
    }
    loginViaMfa(_a) {
        return __awaiter(this, arguments, void 0, function* ({ email, password, mfaCode, rememberDevice, deviceUuid, }) {
            const resp = yield this.client.post(AuthEndpoints.GetAccessToken, qs.stringify({
                username: email,
                password,
                grant_type: TokenGrantType.Mfa,
                mfa_code: mfaCode,
                remember_device: rememberDevice,
                device_uuid: deviceUuid,
            }));
            return resp.data;
        });
    }
    loginViaPartner(_a, requestHeaders_1) {
        return __awaiter(this, arguments, void 0, function* ({ partnerToken, userId }, requestHeaders) {
            const resp = yield this.client.post(AuthEndpoints.GetAccessToken, qs.stringify({
                user_id: userId,
                partner_token: partnerToken,
                grant_type: TokenGrantType.Partner,
            }), requestHeaders ? { headers: requestHeaders } : undefined);
            return resp.data;
        });
    }
    loginViaPassword(_a) {
        return __awaiter(this, arguments, void 0, function* ({ email, password, deviceUuid, }) {
            const resp = yield this.client.post(AuthEndpoints.GetAccessToken, qs.stringify({
                username: email,
                password,
                device_uuid: deviceUuid,
                grant_type: TokenGrantType.Password,
            }));
            return resp.data;
        });
    }
    refreshAccessToken(refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.post(AuthEndpoints.GetAccessToken, qs.stringify({
                refresh_token: refreshToken,
                grant_type: TokenGrantType.RefreshToken,
            }));
            return resp.data;
        });
    }
}
export { AuthClient };
